import { numberToLocaleString } from 'modules/utils';
import { Container, EurContainer } from './styled';

export interface CurrencyContainerProps {
  value?: string;
}

export enum Currency {
  EURO = 'EUR',
}

export const CurrencyContainer: React.FC<CurrencyContainerProps> = ({
  value,
}) => (
  <Container>
    <EurContainer>
      {numberToLocaleString(value)} {Currency.EURO}
    </EurContainer>
  </Container>
);
